<template>
  <div class="user2-page">
    <!-- Main Content -->
    <main class="page-main">
      <!-- 欢迎卡片 -->
      <section class="welcome-card">
        <div class="welcome-content">
          <div class="welcome-text">
            <h1 class="welcome-title">欢迎回来</h1>
            <p class="welcome-desc">开始您的智能视频创作之旅</p>
          </div>
          <div class="welcome-stats">
            <div class="stat-item">
              <span class="stat-value">{{ availablePoints }}</span>
              <span class="stat-label">可用点数</span>
            </div>
          </div>
        </div>
      </section>

      <!-- 功能卡片 -->
      <section class="features-section">
        <h2 class="section-title">
          <app-icon  class="app-icon" name="auto_awesome"></app-icon>
          创作工具
        </h2>
        <div class="features-grid">
          <div class="feature-card" v-for="(item, index) in features" :key="index" @click="$router.push(item.path)">
            <div class="feature-icon" :style="{ background: item.bg }">
              <app-icon  class="app-icon" :name="item.icon"></app-icon>
            </div>
            <div class="feature-info">
              <h3 class="feature-name">{{ item.name }}</h3>
              <p class="feature-desc">{{ item.desc }}</p>
            </div>
            <app-icon  class="app-icon feature-arrow" name="arrow_forward"></app-icon>
          </div>
        </div>
      </section>

      <section class="workflow-entry"><div><h3>查看制作进度</h3><p>已提交的任务、生成结果和下载文件都在这里</p></div><el-button type="primary" plain @click="$router.push('/user2/record')">制作记录 <i class="el-icon-arrow-right"></i></el-button></section>
      <!-- 快捷入口 -->
      <section class="shortcuts-section">
        <h2 class="section-title">
          <app-icon  class="app-icon" name="grid_view"></app-icon>
          快捷入口
        </h2>
        <div class="shortcuts-grid">
          <div class="shortcut-item" v-for="(item, index) in visibleShortcuts" :key="index" @click="$router.push(item.path)">
            <app-icon  class="app-icon shortcut-icon" :name="item.icon"></app-icon>
            <span class="shortcut-name">{{ item.name }}</span>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { getUserProfile } from '@/config/userProfile'

export default {
  name: 'User2Index',
  data() {
    return {
      phone: '****',
      availablePoints: 0,
      hasCdkAuth: window.localStorage.getItem('cdk_auth') === '1',
      features: [
        { name: '视频去重', desc: '智能识别重复帧，提升视频原创度', icon: 'content_cut', bg: '#eff6ff', path: '/user2/qc' },
        { name: '视频混剪', desc: '多素材智能拼接，创作无限可能', icon: 'movie_edit', bg: '#eff6ff', path: '/user2/hj' },
        { name: '起号视频', desc: '快速生成起号视频内容', icon: 'rocket_launch', bg: '#eff6ff', path: '/user/qihao' },
        { name: '聚合好物', desc: '海量好物素材库', icon: 'inventory_2', bg: '#eff6ff', path: '/user2/haowu' },
      ],
      shortcuts: [
        { name: '个人信息', icon: 'person', path: '/user2/info' },
        { name: '购买会员', icon: 'card_membership', path: '/user2/vip' },
        { name: '自由工作台', icon: 'dashboard_customize', path: '/user2/custom' },
        { name: '视频去重', icon: 'content_cut', path: '/user2/qc' },
        { name: '视频去重 V2', icon: 'auto_fix_high', path: '/user2/qcai' },
        { name: '视频混剪', icon: 'movie_edit', path: '/user2/hj' },
        { name: '视频混剪 V2', icon: 'video_library', path: '/user2/hj2' },
        { name: '混剪协同', icon: 'inbox', path: '/user2/ku' },
        { name: '提取视频', icon: 'download', path: '/user2/qsy' },
        { name: '视频去字幕', icon: 'text_fields', path: '/user2/qzm' },
        { name: '图片去水印', icon: 'broken_image', path: '/user2/watermark' },
        { name: '制作记录', icon: 'history', path: '/user2/record' },
        { name: '分享好友', icon: 'share', path: '/user2/share' },
        { name: '代理后台', icon: 'admin_panel_settings', path: '/user2/developer' },
        { name: 'API 开放平台', icon: 'key', path: '/user2/api-key' },
      ]
    }
  },
  computed: {
    // 有兑换码购买权限（代理或兑换码批发用户）时才显示入口
    visibleShortcuts() {
      const tools = this.features.map(item => item.path)
      const shortcuts = this.shortcuts.filter(item => tools.indexOf(item.path) === -1)
      if (!this.hasCdkAuth) return shortcuts
      return shortcuts.concat([{ name: '兑换码', icon: 'redeem', path: '/buy-cdk' }])
    }
  },
  methods: {
    getUserInfo() {
      getUserProfile(this.$ajax, true).then(data => {
        if (data) {
          this.phone = data.phone || '****'
          this.availablePoints = data.available_points || 0
        }
      }).catch(err => {
        console.error('获取用户信息失败', err)
      })
    },
    getCdkAuth() {
      this.$ajax.get('api/v1/proxy/cdks/sellers').then(res => {
        const list = (res.data && res.data.data) || []
        this.hasCdkAuth = list.length > 0
        window.localStorage.setItem('cdk_auth', this.hasCdkAuth ? '1' : '0')
      }).catch(() => {
        this.hasCdkAuth = false
      })
    }
  },
  created() {
    this.getUserInfo()
    this.getCdkAuth()
  }
}
</script>

<style scoped>
.user2-page {
  --c-primary: #0052ff;
  --c-primary-light: #4d8bff;
  --c-bg: #f5f7fa;
  --c-card: #ffffff;
  --c-text: #1a1a2e;
  --c-text-secondary: #6b7280;
  --c-border: #e5e7eb;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* Main */
.page-main {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

/* Welcome Card */
.welcome-card {
  background: linear-gradient(135deg, #0052ff 0%, #003ec7 100%);
  border-radius: 16px;
  padding: 32px;
  margin-bottom: 32px;
  color: #ffffff;
}

.welcome-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.welcome-title {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.welcome-desc {
  font-size: 16px;
  opacity: 0.9;
  margin: 0;
}

.welcome-stats {
  display: flex;
  gap: 32px;
}

.stat-item {
  text-align: center;
}

.stat-value {
  display: block;
  font-size: 36px;
  font-weight: 700;
}

.stat-label {
  font-size: 14px;
  opacity: 0.8;
}

/* Section Title */
.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 600;
  color: var(--c-text);
  margin: 0 0 20px 0;
}

.section-title .app-icon {
  font-size: 24px;
  color: var(--c-primary);
}

/* Features Grid */
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 40px;
}

.feature-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: var(--c-card);
  border-radius: 12px;
  border: 1px solid var(--c-border);
  cursor: pointer;
  transition: all 0.2s;
}

.feature-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  flex-shrink: 0;
}

.feature-icon .app-icon {
  font-size: 24px;
  color: #ffffff;
}

.feature-info {
  flex: 1;
}

.feature-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--c-text);
  margin: 0 0 4px 0;
}

.feature-desc {
  font-size: 13px;
  color: var(--c-text-secondary);
  margin: 0;
}

.feature-arrow {
  font-size: 20px;
  color: var(--c-text-secondary);
}

/* Shortcuts Grid */
.shortcuts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 16px;
}

.shortcut-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px 12px;
  background: var(--c-card);
  border-radius: 12px;
  border: 1px solid var(--c-border);
  cursor: pointer;
  transition: all 0.2s;
}

.shortcut-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: var(--c-primary);
}

.shortcut-icon {
  font-size: 28px;
  color: var(--c-primary);
}

.shortcut-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-text);
}

/* Responsive */
@media (max-width: 768px) {
  .page-header {
    padding: 12px 16px;
  }

  .page-main {
    padding: 16px;
  }

  .welcome-card {
    padding: 24px;
  }

  .welcome-content {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }

  .welcome-title {
    font-size: 24px;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .shortcuts-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.welcome-card { background:#eff6ff; color:#0f172a; border:1px solid #dbeafe; margin-bottom:24px; }
.welcome-desc { color:#64748b; }
.stat-value { color:#2563eb; }
.stat-label { color:#64748b; }
.feature-icon { color:#2563eb; }
.feature-icon .app-icon { color:#2563eb; }
.feature-card { border-radius:14px; box-shadow:none; }
.feature-card:hover { border-color:#93c5fd; box-shadow:0 6px 18px rgba(37,99,235,.06); }
.workflow-entry { display:flex; align-items:center; justify-content:space-between; gap:16px; padding:20px; margin:24px 0; border:1px solid #e2e8f0; border-radius:14px; background:#fff; }
.workflow-entry h3 { margin:0 0 6px; font-size:16px; color:#0f172a; }
.workflow-entry p { margin:0; font-size:13px; color:#64748b; line-height:1.6; }
@media(max-width:640px) { .workflow-entry { align-items:flex-start; flex-direction:column; padding:16px; } .page-main { padding:18px 14px; } .welcome-card { padding:22px 18px; } }

</style>



// WEBPACK FOOTER //
// src/components/User2/Index.vue